import { ATTRIBUTE_PREFIX_EVENT } from "../../enum";
import { extractContentByTag, extractMethodArgument, extractMethodName, isMethodCalling } from "../../util";
import useWatcher from "../useWatcher";
import {isLayer} from '../../../layer/chain/validator/useLayerIdentity'
import { useQueryLayer1 } from "../../../layer/chain/useQueryLayer";
import { callInjectionMethod, checkInjectionMethod, getInjectionMethodByName } from "../../../utils/useInjectMedthod";
import useMap from "../../../utils/useMap";


const extractEventName = (str = '') => {
    let rs = str.replace(ATTRIBUTE_PREFIX_EVENT, '').trim().toLowerCase();
    if (rs.startsWith('on')) {
        rs = rs.slice(2);
    }
    return rs;
}

/**
 *  if the name start with $ means it need retreive argument: argument[INDEX]
 */
const isOriginArgument = name => name.startsWith('$');

const useEventBinding = (() => {

    const caching = useMap();

    const buildArgument = (args, props, argsName) => {
        let argIndex = -1;
        return argsName.map((name) => {
            if (isOriginArgument(name)) {
                argIndex++;
                return args[argIndex]
            } else if (isLayer(props[name])) {
                return useQueryLayer1(props[name]);
            }
            return props[name];
        })
    }

    /**
     * @param {object} props
     * @param {Node} node
     * @param {string} eventName
     * @param {Array<string>} argsName
     */
    const addEvent = (props, node, eventName, methodName, argsName = []) => {
        const method = getInjectionMethodByName(props, methodName);
        if (typeof method !== 'function') {
            return;
        }

        const fn = (...args) => {
            const arrArgs = buildArgument(args, props, argsName);
            callInjectionMethod(props, methodName, arrArgs);
            // getMethod(props, methodName).apply(null, arrArgs);
        }

        const { onPropChanges, onDestroy, onCreated } = useWatcher(props, node, []);
        onCreated(() => {
            node.addEventListener(eventName, fn);
        })
        onDestroy(() => {
            node.removeEventListener(eventName, fn);
        })
    }

    /**
     * @param {{ attrName: string, attrValue: string }} attr
     * @param {object} props
     * @param {Node} node
     */
    return ({ attrName, attrValue }, props, node) => {
        const eventName = extractEventName(attrName);
        const methodName = extractMethodName(attrValue);
        const isCalling = isMethodCalling(attrValue);
        if (isCalling && !checkInjectionMethod(props, methodName)) {
            console.error(`Method "${methodName}" was not injected`)
        } else if (isMethodCalling(attrValue) && methodName.length > 0) {
            const argsName = extractMethodArgument(attrValue);
            addEvent(props, node, eventName, methodName, argsName);
        }
    }
})();

export default useEventBinding;